import { Reward } from '@prometheus/types'

export function calcQuest(bonus: Reward[]) {
  let quest_bonus_total = 0
  bonus?.forEach((bonus) => {
    quest_bonus_total += bonus.amount || 0
  })
  return quest_bonus_total
}
